/* eslint react/no-set-state: 0 */  // needed for wrapping leaflet
import assign from 'object-assign';
import Leaflet from 'leaflet';
import boundsType from 'react-leaflet/lib/types/bounds';
import LeafletMap from 'react-leaflet/lib/Map';

const boundsPropTypes = assign({}, LeafletMap.propTypes);
boundsPropTypes.bounds = boundsType;
delete boundsPropTypes.center;
delete boundsPropTypes.zoom;

/**
 * A Map component that sets its view by bounds instead of center/zoom
 */
export default class BoundsMap extends LeafletMap {
  static propTypes = boundsPropTypes;

  componentDidMount() {
    super.componentDidMount();
    setTimeout(() => {  // in dev, wait for CSS to be injected
      this.leafletElement.fitBounds(this.props.bounds);
    }, 0);
    this.setState({map: this.leafletElement});
    window.map = this;
  }

  componentDidUpdate({ bounds: oldBounds }) {
    const { bounds } = this.props;
    if (bounds && this.shouldUpdateBounds(bounds, oldBounds)) {
      this.leafletElement.fitBounds(bounds);
    }
  }

  shouldUpdateBounds(next, prev) {
    if (!prev) {
      return true;
    }
    const nextLLB = Leaflet.latLngBounds(next);
    const prevLLB = Leaflet.latLngBounds(prev);
    return !nextLLB.equals(prevLLB);
  }

  resetZoom() {
    const zeroBounds = [[16.00, -21.13], [12.76, -10.43]];
    this.leafletElement.fitBounds(zeroBounds);
  }
}



/** WEBPACK FOOTER **
 ** ./app/scripts/components/leaflet/bounds-map.jsx
 **/